var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container"},[_vm._m(0),_c('SwiperSlider',_vm._l((_vm.testimonials),function(item,index){return _c('swiper-slide',{key:`chs-${index}`},[_c('ChannelsSectionBox',{attrs:{"data":item}})],1)}),1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"alfa text-white mb-4"},[_vm._v(" Celebrating Our "),_c('br'),_c('strong',[_vm._v("Client’s Success")])])
}]

export { render, staticRenderFns }